import Icon from 'molecules/Icon';
import Link from 'molecules/Link';
import styles from 'molecules/ResourceCard/resource-card.module.scss';

import { replaceFirstPathSegment } from 'utils/functions';

import type { IconIds } from 'molecules/Icon';
import type { FC } from 'react';

export interface ResourceCardProps {
  title: string | null;
  model: string | null;
  link: string | null;
}

export const parsePbrType = (type: string) => {
  let parsedType;
  const types = ['business', 'practice', 'regulation'];
  for (let i = 0; i < types.length; i++) {
    if (type.toLowerCase().includes(types[i])) {
      parsedType = types[i];
      break;
    }
  }

  return parsedType;
};

const ResourceCard: FC<ResourceCardProps> = ({ title, model, link }) => {
  const lowerCasedModel = model?.toLowerCase();
  const updatedUrl = replaceFirstPathSegment(link || '', 'healthcare-insights') ?? '';

  return (
    <article className={styles.card}>
      {title && (
        <h3 className={styles.title}>
          <Link className={styles.link} href={updatedUrl}>
            {title}
          </Link>
        </h3>
      )}
      <span className={styles.contentType}>
        {lowerCasedModel && <Icon className={styles.icon} icon={lowerCasedModel as IconIds} size={20} />}
        {model}
      </span>
    </article>
  );
};

export default ResourceCard;
